<template>
  <v-select
    class="basemap-select"
    :items="basemaps"
    solo
    aria-label="Velg bakgrunnskart"
    v-model="selectedBasemap"
    @change="setBasemap"
    aria-expanded="false"
    hide-details
    item-text="title"
    return-object
  >
    <template slot="item" slot-scope="data">
      <v-list-item-avatar>
        <img alt="kartbilde" :src="data.item.thumbnailUrl" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-html="data.item.title"></v-list-item-title>
      </v-list-item-content>
    </template>
    <template slot="selection" slot-scope="data">
      <v-list-item-avatar :size="30">
        <img alt="kartbilde" :src="data.item.thumbnailUrl" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-html="data.item.title"></v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "MapBasemapToggle",
  props: ["basemaps"],
  methods: {
    ...mapActions(["setSelectedBasemap"]),
    setBasemap(basemap) {
      this.$emit("basemap-changed", basemap);
    },
  },
  computed: {
    selectedBasemap: {
      set(selectedBasemap) {
        this.setSelectedBasemap(selectedBasemap);
      },
      get() {
        return this.$store.state.selectedBasemap;
      },
    },
  },
};
</script>
<style>
.basemap-select {
  max-width: 250px;
  margin-top: 4px;
}
</style>
